import PropertyRoomAddOnsCard from './PropertyRoomAddOnsCard';

export default PropertyRoomAddOnsCard;
